// API 配置
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://xyvn-shop-api.arvix1413.workers.dev';

// 完整的 API URL
export function getApiUrl(path: string): string {
  // 如果路径已经是完整 URL，直接返回
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // 移除开头的斜杠（如果有）
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // 拼接基础 URL 和路径
  return `${API_BASE_URL}/${cleanPath}`;
}
